import React from 'react';
import { formatValue } from '../utils/formatters';

const ContentDescriptionModal = ({ isOpen, onClose, contentDescription, pageTitle, pageUrl }) => {
    if (!isOpen || !contentDescription || typeof contentDescription !== 'object') {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1400px',
                    maxHeight: '90vh',
                    backgroundColor: '#121212',
                    borderRadius: '10px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.55)',
                    border: '1px solid rgba(100, 181, 246, 0.35)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: 'rgba(220, 53, 69, 0.92)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(220, 53, 69, 0.45)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'rgba(207, 46, 60, 0.95)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.92)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: '#0c0c0c',
                        padding: '24px'
                    }}
                >
                    <h3
                        style={{
                            margin: '0 0 8px 0',
                            color: '#e0e0e0',
                            fontWeight: '600',
                            fontSize: '20px'
                        }}
                    >
                        Content Description
                    </h3>
                    {pageTitle && (
                        <div style={{
                            fontSize: '14px',
                            color: '#a0a0a0',
                            marginBottom: '8px'
                        }}>
                            {pageTitle}
                        </div>
                    )}
                    {pageUrl && (
                        <a
                            href={pageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#60a5fa',
                                textDecoration: 'none',
                                fontSize: '12px',
                                wordBreak: 'break-all',
                                display: 'block',
                                marginBottom: '24px'
                            }}
                            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                        >
                            {pageUrl}
                        </a>
                    )}

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px'
                    }}>
                        {/* Page Overview */}
                        {contentDescription.page_overview && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Page Overview
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    fontSize: '13px'
                                }}>
                                    {contentDescription.page_overview.page_title && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Title: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.page_overview.page_title)}</span>
                                        </div>
                                    )}
                                    {contentDescription.page_overview.primary_purpose && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Primary Purpose: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.page_overview.primary_purpose)}</span>
                                        </div>
                                    )}
                                    {contentDescription.page_overview.intended_audience && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Intended Audience: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.page_overview.intended_audience)}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Core Message */}
                        {contentDescription.core_message && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Core Message
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    fontSize: '13px'
                                }}>
                                    {contentDescription.core_message.main_idea && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Main Idea: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.core_message.main_idea)}</span>
                                        </div>
                                    )}
                                    {contentDescription.core_message.one_sentence_summary && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Summary: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.core_message.one_sentence_summary)}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Content Structure */}
                        {contentDescription.content_structure && Array.isArray(contentDescription.content_structure) && contentDescription.content_structure.length > 0 && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Content Structure ({contentDescription.content_structure.length} sections)
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px',
                                    maxHeight: '400px',
                                    overflowY: 'auto'
                                }}>
                                    {contentDescription.content_structure.map((section, idx) => (
                                        <div key={idx} style={{
                                            backgroundColor: '#0c0c0c',
                                            border: '1px solid rgba(100, 181, 246, 0.08)',
                                            borderRadius: '6px',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#e0e0e0',
                                                marginBottom: '8px'
                                            }}>
                                                {section.section_name || `Section ${idx + 1}`}
                                            </div>
                                            {section.summary && (
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#d0d0d0',
                                                    marginBottom: '8px'
                                                }}>
                                                    {formatValue(section.summary)}
                                                </div>
                                            )}
                                            {section.content_type && (
                                                <div style={{
                                                    fontSize: '11px',
                                                    color: '#909090',
                                                    fontStyle: 'italic',
                                                    marginBottom: '8px'
                                                }}>
                                                    Type: {formatValue(section.content_type)}
                                                </div>
                                            )}
                                            {section.key_points && Array.isArray(section.key_points) && section.key_points.length > 0 && (
                                                <div style={{ marginTop: '8px' }}>
                                                    <div style={{
                                                        fontSize: '11px',
                                                        color: '#909090',
                                                        marginBottom: '6px',
                                                        fontWeight: '600'
                                                    }}>
                                                        Key Points:
                                                    </div>
                                                    <ul style={{
                                                        margin: 0,
                                                        paddingLeft: '20px',
                                                        fontSize: '12px',
                                                        color: '#d0d0d0'
                                                    }}>
                                                        {section.key_points.map((point, pointIdx) => (
                                                            <li key={pointIdx} style={{ marginBottom: '4px' }}>{formatValue(point)}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                            {section.important_details && Array.isArray(section.important_details) && section.important_details.length > 0 && (
                                                <div style={{ marginTop: '8px' }}>
                                                    <div style={{
                                                        fontSize: '11px',
                                                        color: '#909090',
                                                        marginBottom: '6px',
                                                        fontWeight: '600'
                                                    }}>
                                                        Important Details:
                                                    </div>
                                                    <ul style={{
                                                        margin: 0,
                                                        paddingLeft: '20px',
                                                        fontSize: '12px',
                                                        color: '#d0d0d0'
                                                    }}>
                                                        {section.important_details.map((detail, detailIdx) => (
                                                            <li key={detailIdx} style={{ marginBottom: '4px' }}>{formatValue(detail)}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Key Information */}
                        {contentDescription.key_information && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Key Information
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px'
                                }}>
                                    {contentDescription.key_information.facts_explanations && Array.isArray(contentDescription.key_information.facts_explanations) && contentDescription.key_information.facts_explanations.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '6px',
                                                fontWeight: '600'
                                            }}>
                                                Facts & Explanations:
                                            </div>
                                            <ul style={{
                                                margin: 0,
                                                paddingLeft: '20px',
                                                fontSize: '12px',
                                                color: '#d0d0d0'
                                            }}>
                                                {contentDescription.key_information.facts_explanations.map((fact, idx) => (
                                                    <li key={idx} style={{ marginBottom: '4px' }}>{formatValue(fact)}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    {contentDescription.key_information.statistics_numbers && Array.isArray(contentDescription.key_information.statistics_numbers) && contentDescription.key_information.statistics_numbers.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '6px',
                                                fontWeight: '600'
                                            }}>
                                                Statistics & Numbers:
                                            </div>
                                            <ul style={{
                                                margin: 0,
                                                paddingLeft: '20px',
                                                fontSize: '12px',
                                                color: '#d0d0d0'
                                            }}>
                                                {contentDescription.key_information.statistics_numbers.map((stat, idx) => (
                                                    <li key={idx} style={{ marginBottom: '4px' }}>{formatValue(stat)}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    {contentDescription.key_information.terminology_concepts && Array.isArray(contentDescription.key_information.terminology_concepts) && contentDescription.key_information.terminology_concepts.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '6px',
                                                fontWeight: '600'
                                            }}>
                                                Terminology & Concepts:
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '6px'
                                            }}>
                                                {contentDescription.key_information.terminology_concepts.map((term, idx) => (
                                                    <span key={idx} style={{
                                                        backgroundColor: '#1e3a5f',
                                                        color: '#60a5fa',
                                                        padding: '4px 10px',
                                                        borderRadius: '4px',
                                                        fontSize: '11px'
                                                    }}>
                                                        {formatValue(term)}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Functional Content */}
                        {contentDescription.functional_content && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Functional Content
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px'
                                }}>
                                    {contentDescription.functional_content.forms_inputs && Array.isArray(contentDescription.functional_content.forms_inputs) && contentDescription.functional_content.forms_inputs.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '8px',
                                                fontWeight: '600'
                                            }}>
                                                Forms & Inputs:
                                            </div>
                                            {contentDescription.functional_content.forms_inputs.map((form, idx) => (
                                                <div key={idx} style={{
                                                    backgroundColor: '#0c0c0c',
                                                    border: '1px solid rgba(100, 181, 246, 0.08)',
                                                    borderRadius: '6px',
                                                    padding: '10px',
                                                    marginBottom: '8px',
                                                    fontSize: '12px'
                                                }}>
                                                    <div style={{ color: '#d0d0d0', marginBottom: '4px' }}>
                                                        {formatValue(form.form_description)}
                                                    </div>
                                                    {form.info_collected && (
                                                        <div style={{ color: '#909090', fontSize: '11px' }}>
                                                            Info: {formatValue(form.info_collected)}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {contentDescription.functional_content.calls_to_action && Array.isArray(contentDescription.functional_content.calls_to_action) && contentDescription.functional_content.calls_to_action.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '8px',
                                                fontWeight: '600'
                                            }}>
                                                Calls to Action ({contentDescription.functional_content.calls_to_action.length}):
                                            </div>
                                            <div style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                                gap: '8px'
                                            }}>
                                                {contentDescription.functional_content.calls_to_action.map((cta, idx) => (
                                                    <div key={idx} style={{
                                                        backgroundColor: '#0c0c0c',
                                                        border: '1px solid rgba(100, 181, 246, 0.08)',
                                                        borderRadius: '6px',
                                                        padding: '10px',
                                                        fontSize: '12px'
                                                    }}>
                                                        <div style={{ color: '#d0d0d0', fontWeight: '600', marginBottom: '4px' }}>
                                                            {formatValue(cta.cta_text)}
                                                        </div>
                                                        {cta.cta_purpose && (
                                                            <div style={{ color: '#909090', fontSize: '11px' }}>
                                                                {formatValue(cta.cta_purpose)}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {contentDescription.functional_content.interactive_elements && Array.isArray(contentDescription.functional_content.interactive_elements) && contentDescription.functional_content.interactive_elements.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '8px',
                                                fontWeight: '600'
                                            }}>
                                                Interactive Elements:
                                            </div>
                                            {contentDescription.functional_content.interactive_elements.map((element, idx) => (
                                                <div key={idx} style={{
                                                    backgroundColor: '#0c0c0c',
                                                    border: '1px solid rgba(100, 181, 246, 0.08)',
                                                    borderRadius: '6px',
                                                    padding: '10px',
                                                    marginBottom: '8px',
                                                    fontSize: '12px'
                                                }}>
                                                    <div style={{ color: '#d0d0d0', marginBottom: '4px' }}>
                                                        {formatValue(element.element_description)}
                                                    </div>
                                                    {element.element_purpose && (
                                                        <div style={{ color: '#909090', fontSize: '11px' }}>
                                                            Purpose: {formatValue(element.element_purpose)}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Tone & Style */}
                        {contentDescription.tone_style && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Tone & Style
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    fontSize: '13px'
                                }}>
                                    {contentDescription.tone_style.tone && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Tone: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.tone_style.tone)}</span>
                                        </div>
                                    )}
                                    {contentDescription.tone_style.point_of_view && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Point of View: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.tone_style.point_of_view)}</span>
                                        </div>
                                    )}
                                    {contentDescription.tone_style.complexity_level && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Complexity Level: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.tone_style.complexity_level)}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Page Intent */}
                        {contentDescription.page_intent && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Page Intent
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    fontSize: '13px'
                                }}>
                                    {contentDescription.page_intent.what_page_tries_to_accomplish && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Goal: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.page_intent.what_page_tries_to_accomplish)}</span>
                                        </div>
                                    )}
                                    {contentDescription.page_intent.how_well_content_supports_goal && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Support: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.page_intent.how_well_content_supports_goal)}</span>
                                        </div>
                                    )}
                                    {contentDescription.page_intent.gaps_missing_information && Array.isArray(contentDescription.page_intent.gaps_missing_information) && contentDescription.page_intent.gaps_missing_information.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '6px',
                                                fontWeight: '600'
                                            }}>
                                                Gaps & Missing Information:
                                            </div>
                                            <ul style={{
                                                margin: 0,
                                                paddingLeft: '20px',
                                                fontSize: '12px',
                                                color: '#d0d0d0'
                                            }}>
                                                {contentDescription.page_intent.gaps_missing_information.map((gap, idx) => (
                                                    <li key={idx} style={{ marginBottom: '4px' }}>{formatValue(gap)}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Metadata Content */}
                        {contentDescription.metadata_content && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Metadata Content
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px'
                                }}>
                                    {contentDescription.metadata_content.seo_keywords && Array.isArray(contentDescription.metadata_content.seo_keywords) && contentDescription.metadata_content.seo_keywords.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '8px',
                                                fontWeight: '600'
                                            }}>
                                                SEO Keywords ({contentDescription.metadata_content.seo_keywords.length}):
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '6px'
                                            }}>
                                                {contentDescription.metadata_content.seo_keywords.map((keyword, idx) => (
                                                    <span key={idx} style={{
                                                        backgroundColor: '#1e3a5f',
                                                        color: '#60a5fa',
                                                        padding: '4px 10px',
                                                        borderRadius: '4px',
                                                        fontSize: '11px'
                                                    }}>
                                                        {formatValue(keyword)}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {contentDescription.metadata_content.headings && Array.isArray(contentDescription.metadata_content.headings) && contentDescription.metadata_content.headings.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '8px',
                                                fontWeight: '600'
                                            }}>
                                                Headings ({contentDescription.metadata_content.headings.length}):
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '6px',
                                                maxHeight: '300px',
                                                overflowY: 'auto'
                                            }}>
                                                {contentDescription.metadata_content.headings.map((heading, idx) => (
                                                    <div key={idx} style={{
                                                        backgroundColor: '#0c0c0c',
                                                        border: '1px solid rgba(100, 181, 246, 0.08)',
                                                        borderRadius: '6px',
                                                        padding: '8px',
                                                        fontSize: '12px'
                                                    }}>
                                                        <div style={{ color: '#d0d0d0', fontWeight: '600', marginBottom: '4px' }}>
                                                            {formatValue(heading.heading_text)}
                                                        </div>
                                                        {heading.what_it_communicates && (
                                                            <div style={{ color: '#909090', fontSize: '11px' }}>
                                                                {formatValue(heading.what_it_communicates)}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {contentDescription.metadata_content.links && Array.isArray(contentDescription.metadata_content.links) && contentDescription.metadata_content.links.length > 0 && (
                                        <div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#909090',
                                                marginBottom: '8px',
                                                fontWeight: '600'
                                            }}>
                                                Links ({contentDescription.metadata_content.links.length}):
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '6px',
                                                maxHeight: '300px',
                                                overflowY: 'auto'
                                            }}>
                                                {contentDescription.metadata_content.links.map((link, idx) => (
                                                    <div key={idx} style={{
                                                        backgroundColor: '#0c0c0c',
                                                        border: '1px solid rgba(100, 181, 246, 0.08)',
                                                        borderRadius: '6px',
                                                        padding: '8px',
                                                        fontSize: '12px'
                                                    }}>
                                                        <div style={{ color: '#d0d0d0', marginBottom: '4px' }}>
                                                            {formatValue(link.link_text)}
                                                        </div>
                                                        {link.link_destination && (
                                                            <div style={{ color: '#909090', fontSize: '11px' }}>
                                                                → {formatValue(link.link_destination)}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Summary */}
                        {contentDescription.summary && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    textTransform: 'uppercase',
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Summary
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    fontSize: '13px'
                                }}>
                                    {contentDescription.summary.what_user_learns && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>What User Learns: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.summary.what_user_learns)}</span>
                                        </div>
                                    )}
                                    {contentDescription.summary.page_importance && (
                                        <div>
                                            <span style={{ color: '#909090', fontWeight: '600' }}>Page Importance: </span>
                                            <span style={{ color: '#d0d0d0' }}>{formatValue(contentDescription.summary.page_importance)}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentDescriptionModal;





